module.exports = __webpack_public_path__ + "img/empty-cart.f1625b21.png";